import React from 'react'
import { Route, Routes } from 'react-router'
import Dashboard from './Dashboard/Dashboard'
import { AdminLayout } from '../../components/layout/Layout/Layout'
import DocumentsPage from './Documents/Documents'
import QAManagement from './QAManagement/QAManagement'
import EmailManagement from './EmailManagement/EmailManagement'

function Admin() {
  return (
    <div>
        <AdminLayout>

   <Routes>
    <Route path='/' element={<Dashboard />} />
    <Route path='/documents' element={<DocumentsPage />} />
    <Route path='/qa-management' element={<QAManagement />} />
    <Route path='/email-management' element={<EmailManagement />} />
    </Routes>   
        </AdminLayout>
    </div>
  )
}

export default Admin
